import { Tag } from 'antd'
import { STATUS_LABELS, STATUS_COLORS } from '@/lib/constants'

/** O hex vira fundo com 10% de opacidade, para a tag ficar leve como no restante do painel. */
export function TagDeStatus({ statusDetran }: { statusDetran: string }) {
  const cor = STATUS_COLORS[statusDetran] ?? '#8c8c8c'

  return (
    <Tag className="!mr-0 !border-0 !font-medium" style={{ color: cor, backgroundColor: `${cor}1a` }}>
      {STATUS_LABELS[statusDetran] ?? statusDetran}
    </Tag>
  )
}
